import { Component, OnInit, Inject } from '@angular/core';
import { ArbreComposant } from 'src/app/model/arbre/arbre-composant';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TreeService } from 'src/app/services/http/tree/tree.service';
import { CHILD, ElementChooserComponent, PARENT } from '../element-chooser/element-chooser/element-chooser.component';
import { TreeType } from 'src/app/model/arbre/arbre-type';
import { CallService } from 'src/app/services/http/call/call.service';
import { CodePanne } from 'src/app/model/call/call.model';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { DialogService } from 'src/app/services/dialog-service.service';
import { DialogOverViewComponent } from '../../dialog-over-view/dialog-over-view.component';
import { UtilsService } from 'src/app/services/tools/utils.service';
import { UserService } from 'src/app/services/http/user/user.service';

/**
 * Expected incoming data structure
 * composant : the element to edit
 * parent : the parent of element to edit // can probably be retrieved upon init
 * edition : true if EditArbreComponent is called for edition, false if called for creation
 * iamroot : is the composant passed the root of the tree ? // can probably be retrieved upon init
 */
export interface ArbreEditorData {
  composant : ArbreComposant;
  parent: ArbreComposant;
  edition: boolean;
  iamroot: boolean;
  forcedType: string;
}


@Component({
  selector: 'app-edit-arbre',
  templateUrl: './edit-arbre.component.html',
  styleUrls: ['./edit-arbre.component.scss']
})

export class EditArbreComponent implements OnInit {
  /** Codes pannes selected in multi select */
  public selectedCodes!: any;

  formComposant!: FormGroup;
  public arbreTypes!: TreeType[];
  /** List of displayed children */
  public children!: ArbreComposant[];
  /** Displayed parent */
  public parent!: ArbreComposant;
  public forEdition!: boolean;
  codesPannes!: CodePanne[];
  selectedPannes!: CodePanne[];
  public isValidated: boolean = true;
  public iAmRoot = false;
  public isSolution = false;
  chosenType!: string;
  currentComposant!: ArbreComposant;
  chosenChildrenType!: string;
  /** Indicates if we are displaying form for Admin (more actions available) or not */
  public forAdmin!: boolean;
  public determinedType!: string;

  constructor(public dialogRef: MatDialogRef<ArbreEditorData>, 
              public dialog: MatDialog, 
              @Inject(MAT_DIALOG_DATA) public data: ArbreEditorData,
              private formBuilder: FormBuilder,
              public treeService: TreeService,
              private service: CallService,
              public dialogService: DialogService,
              private utilsService: UtilsService,
              private userService: UserService) {
   }

  ngOnInit(): void {
    this.dialogRef.updateSize('80%', '90%');
    this.forAdmin = localStorage.getItem('isAdmin')=='true';
    this.forEdition = this.data.edition;
    this.iAmRoot = this.data.iamroot;
    this.determinedType = this.data.forcedType;
    this.parent = this.data.parent;
    console.log(this.data)
    /** Load the breakdowns codes available */
    this.service.getCodesPannes().subscribe((codesPannes) => {
      this.codesPannes = codesPannes;
      this.selectedPannes = this.codesPannes; 
    });
    this.selectedCodes = this.parent.codes_pannes;
    this.treeService.getTreeTypes().subscribe((treeTypes) => {
      this.arbreTypes = treeTypes;
    });


    if( this.forEdition ){
      this.setupForEdition();
    } else {
      this.setupForCreation();
    }
  }

  setupForCreation() {
    
    

    let forcedType = '';
    if(this.determinedType){
      forcedType = this.determinedType;
      this.chosenType = forcedType;
    }

    this.formComposant = this.formBuilder.group({
        label: [ '' ],
        type: new FormControl( forcedType ),
        codePanne : [this.parent.codes_pannes],
        childrenType: new FormControl( '' ),
    });

    this.formComposant.get('type')?.valueChanges.subscribe(changeEvent => { this.typeChanged(changeEvent) })
  }

  setupForEdition() {
    this.currentComposant = this.data.composant;
    console.log(this.currentComposant.children_type)
    if( this.currentComposant.type == 'Solution' ){
      this.isSolution = true;
    }

    this.formComposant = this.formBuilder.group({
        label: [ this.currentComposant.label ],
        type: new FormControl( this.currentComposant.type ),
        codePanne : [''],
        childrenType:  [this.currentComposant.children_type] 
    }); 



    this.formComposant.get('type')!.setValue(this.currentComposant.type);
  
    this.getChildren( false );

    if( this.currentComposant.codes_pannes ){
      this.formComposant.get('codePanne')!.setValue( this.currentComposant.codes_pannes );
      this.selectedCodes = this.currentComposant.codes_pannes;
    }
  }

  updateParent( id: number ) {
    this.treeService.getComposant( id ).then( parent => {
      this.parent = parent;
    })
  }

  updateChildren( ids: string[] ){
    this.treeService.getComposantsByIds( ids ).subscribe( children =>{
      this.children = children;
     
    })
  }

  getChildren( andReload: boolean ) : void{
    this.treeService.getChildren( this.data.composant ).then( children =>{
      this.children = children;
      if( andReload ){
        this.updateComponentChildren();
      }
    })
  }

  onSubmit(): void{

    const newLabel = this.formComposant.get('label')?.value;
    const newType = this.formComposant.get('type')?.value;
    const newChildrenType = this.formComposant.get('childrenType')?.value;
    let newPannes = this.formComposant.get('codePanne')?.value;

    if( !this.utilsService.checkNotEmpty(newLabel) ){
      this.confirmDone('Le texte est obligatoire', false);
      return;
    }
    if( !this.utilsService.checkNotEmpty(newType) ){
      this.confirmDone('Le type est obligatoire', false);
      return;
    }
    if( !this.utilsService.checkNotEmpty(newChildrenType)  && newType != 'Solution'){
      this.confirmDone('Le type des enfants est obligatoire', false);
      return;
    }

    if( !this.utilsService.checkNotEmpty(newPannes) ){
      newPannes = [];
    }

    /** loading while request, inform done, close this */

    if( this.forEdition ){
      this.data.composant.codes_pannes = newPannes;
      this.data.composant.label =  newLabel;
      this.currentComposant.children_type = newChildrenType;
      console.log(this.children);
      this.currentComposant.children_id = []
      this.children.forEach(child =>{
        this.currentComposant.children_id.push(child.id.toString());
      })
      this.doUpdateComponent( this.data.composant );
    } else {
      if( !this.currentComposant){
        this.currentComposant = new ArbreComposant();
      }

      this.currentComposant.type = newType;
      this.currentComposant.children_type = newChildrenType;
      this.currentComposant.label = newLabel;
      this.currentComposant.codes_pannes = newPannes;

      if( this.parent ){
        this.currentComposant.parent_id = this.parent.id;
      }

      if(!this.currentComposant.children_id){
        this.currentComposant.children_id = [];
      }

      this.doUpdateComponent( this.currentComposant );
    }

   
  }

  typeChanged( changeEvent: any ) {
    if(changeEvent.value){
      this.chosenType = changeEvent.value;
      if( this.chosenType == 'Solution'){
        this.isSolution = true;
      }else{
        this.isSolution = false;
      }
    }
  }

  childrenTypeChanged( changeEvent: any ) {
    if(changeEvent.value){
      this.chosenChildrenType = changeEvent.value;
    }
  }

  doUpdateComponent( toUpdate: ArbreComposant) {
    this.currentComposant.validated = this.isValidated;
    this.treeService.updateComposant( toUpdate ).subscribe(res=>{
      if(res){
        this.confirmDone('Elément mis à jour', true);
      } else{
        this.confirmDone('Erreur ! Impossible de mettre à jour l\'élément', true);
      }
    }); 
  }

  /* Inform user action succesfully done  */
  confirmDone( msg : string, close: boolean) {
      const dialogRef = this.dialog.open(DialogOverViewComponent, {
        width: '30%',
        data: { message: msg }
      });
      dialogRef.afterClosed().subscribe(
        res => {
          if( close ){
            if(this.determinedType){
              this.dialogRef.close({data: {reloadChildren:true}});
            } else {
              this.dialogRef.close({data:this.data.composant});
            }
          }
      });
  }

  /**
   * Edit parent or children
   * @param typeToLink 1 is for Parent; 2 is for Children 
   */
  editLinks( typeToLink: number ){
    let dataTosend;
    if( !this.forEdition && !this.chosenType && typeToLink == PARENT ){
      this.confirmDone('Choisissez un type d\'élément parent d\'abord', false);
      return;
    } 
    
    if( !this.forEdition && !this.chosenChildrenType && typeToLink == CHILD ){
      this.confirmDone('Choisissez un type d\'élément enfants d\'abord', false);
      return;
    } 
    
    if ( !this.forEdition ){
      dataTosend = new ArbreComposant();
      dataTosend.type = this.chosenType;
      dataTosend.children_type = this.chosenChildrenType;
      dataTosend.children_id = [];
    } else {
      dataTosend = this.currentComposant;
    }

    const dialogRef = this.dialog.open(ElementChooserComponent,{
      data: {
        composant : dataTosend,
        typeOfLink: typeToLink
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if( result && result.data){
        this.currentComposant = result.data;
        if( result.relation == PARENT) { 
          this.updateParent( this.currentComposant.parent_id );
        } else {
          this.updateChildren( this.currentComposant.children_id );
        }
      }
    });
  }

  /** Delete a children from displayed children (ui). Then calls updateComponentChildren() to updated model */
  deleteChild(childToDelete: ArbreComposant){
    /** Filter children displayed */
    this.children = this.children.filter(child =>{ return child.id != childToDelete.id});
    /** Update component's children */
    this.updateComponentChildren();
  }

  /** Update the current element's (model) children list with data returned from ElementChooserComponent */
  updateComponentChildren() {
    this.data.composant.children_id = [];
    this.children.forEach(child=>{
      this.data.composant.children_id.push( child.id.toString() );
    });
  }

  /** Handler so that user can filter the Codes Pannes select by typing characters in the select search field  */
  onKey(event: any) {  
    this.selectedPannes = this.searchPannes(event.target.value);
  }
  
  /** Filter the codes pannes shown in Code Pannes Select (ui)  */
  searchPannes(value: string) { 
    let filter = value.toLowerCase();
    return this.codesPannes.filter(option => option.nom.toLowerCase().includes(filter) || option.code.toLowerCase().includes(filter));
  }

  /**
   * Handle drag and drop event, allowing child elements list reordering
   * @param event the drag event
   */
  drop(event: CdkDragDrop<ArbreComposant[]>) {
    moveItemInArray(this.children, event.previousIndex, event.currentIndex);
    this.updateComponentChildren();
  }

  /**
 * Handle click on the "Delete" Button. Only availbable to Admin
 */
  deleteElement(){
    /** Ask confirmation */
    const overdialogRef = this.dialog.open(DialogOverViewComponent, {
      width:  '30%',
      data: {title: 'Attention', message: 'Etes vous sûr de vouloir supprimer cet élément ?', forConfirmation: true}
    });
   
    overdialogRef.afterClosed().subscribe(
      res => {
        /** User confirmed he wants to delete the element */
        if( res ){
          this.treeService.deleteElement( this.data.composant.id ).subscribe(ok => {
            if( ok ){ /** Server answered true */
              this.confirmDone('Elément supprimé', true);
            } else {
              this.confirmDone('Erreur lors de la suppression', false);
            }
        })
        }
      });
  }

  /** Close this Component
   * Bound to "Cancel" button
   */
  close(){
    this.dialogRef.close();
  }

  /** Format pretty dates */
  getNiceDate(toFormat : string): string{
    return this.utilsService.getNiceDateHeure(toFormat);
  }

  /** Hanlder for "validate modificaitons" checkbox. Only Admin sees this checkbox */
  validateComponent(event: any){
    this.isValidated = event.checked;
  }

  /** Create a new element */
  newElement(){
    const data =  {
      edition: false,
      iamroot: false,
      forcedType: this.currentComposant.children_type,
      parent: this.currentComposant
    };

    this.openDialog(data);
  }  

  /**
   * Open a new EditArbreComponent (inception)
   * Used to create a new child inside current composant being edited
   * @param toPass the data to pass to EditArbreComponent
   */
  openDialog( toPass: any): void {
    const editDiag = this.dialog.open(EditArbreComponent,{
      data: toPass
    });

    /** When closing inceptionned  EditArbreComponent, children have to be reloaded */
    editDiag.afterClosed().subscribe(evt=>{
      if( evt.data.reloadChildren  ){
        this.getChildren( true );
      }
    })
  }
}
